module.exports = __webpack_public_path__ + "static/img/img-main-sam.b05c2461.png";